import './card-sanded.sass'
import {Button, Col, Flex, Image, Row, Space} from 'antd'
import {ButtonLinkLike} from '../buttons/ButtonLinkLike'
import Icon from '../helpers/Icon'

export default function CardSanded({image = null, title = '', content = '', actions = null, help_text = "", ...props}) {
  return (

    <div className="card-sanded ta-left">
      <Row gutter={[0,0]} align="stretch">
        <Col xs={24} sm={24} md={8} lg={8}>
          <div className="image-wrapper">
            <Image src={image} preview={false}/>
          </div>
        </Col>
        <Col xs={24} sm={24} md={16} lg={16}>
          <div className="card-content">
            <h3 className="card-title">{title}</h3>
            <p className="card-description">{content}</p>

            <Space className="card-action ta-center mt-3 mb-1" wrap={true}>
              {actions}
            </Space>

            {help_text && <p className="fs-small ta-center mt-0 _grey-primary-text">{help_text}</p>}

          </div>
        </Col>
      </Row>
    </div>

  )
}